import { useParams, useSearchParams } from 'react-router-dom';
import type { PermitParams } from '../types/breadcrumbTypes';

/**
 * Custom hook for breadcrumb URL params.
 * Returns route params, search params, and a filter function.
 */
export const useBreadcrumbParams = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const getPermittedSearch = (permit?: PermitParams): string => {
    if (permit === false) return '';
    if (permit === undefined) {
      const all = searchParams.toString();
      return all ? `?${all}` : '';
    }

    const filtered = new URLSearchParams();
    for (const key of permit) {
      if (searchParams.has(key)) {
        filtered.set(key, searchParams.get(key)!);
      }
    }
    const result = filtered.toString();
    return result ? `?${result}` : '';
  };

  return { params, searchParams, getPermittedSearch };
};
